import styles from './spinnerDiv.module.css'
import { Spinner } from "./spinner"
import { useRef } from 'react'

type Props = {
    size?: 's' | 'm' | 'l'
    label?: string
    height?: number
}
export const SpinnerDiv = (props: Props) => {
    const { size = 'l', label, height = 500 } = props
    const containerRef = useRef<HTMLDivElement>(null)
    
    return (
        <div ref={containerRef} className={styles.container} style={{ height }}>
            <Spinner size={size} label={label} />
        </div>
    )
}
